import Routers from './pages/routes';

import './App.css';

function App() {
  return (
    <Routers />
  );
}

export default App;
